var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromptBuilder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_31560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 16C8.16047 15.3704 7.54033 14.4925 7.22743 13.4908C6.91453 12.4892 6.92473 11.4144 7.25658 10.4189C7.58844 9.4233 8.22512 8.55739 9.07645 7.94379C9.92778 7.33019 10.9506 7 12 7C13.0494 7 14.0722 7.33019 14.9236 7.94379C15.7749 8.55739 16.4116 9.4233 16.7434 10.4189C17.0753 11.4144 17.0855 12.4892 16.7726 13.4908C16.4597 14.4925 15.8395 15.3704 15 16C14.6096 16.3865 14.3156 16.8594 14.1419 17.3806C13.9681 17.9018 13.9195 18.4566 14 19C14 19.5304 13.7893 20.0391 13.4142 20.4142C13.0391 20.7893 12.5304 21 12 21C11.4696 21 10.9609 20.7893 10.5858 20.4142C10.2107 20.0391 10 19.5304 10 19C10.0805 18.4566 10.0319 17.9018 9.85813 17.3806C9.6844 16.8594 9.39043 16.3865 9 16Z",
    stroke: "#838FB4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69995 17H14.3",
    stroke: "#838FB4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 9.125C2.31202 9.125 2.61126 9.24353 2.83189 9.4545C3.05252 9.66548 3.17647 9.95163 3.17647 10.25C3.17647 9.95163 3.30042 9.66548 3.52105 9.4545C3.74168 9.24353 4.04092 9.125 4.35294 9.125C4.04092 9.125 3.74168 9.00647 3.52105 8.7955C3.30042 8.58452 3.17647 8.29837 3.17647 8C3.17647 8.29837 3.05252 8.58452 2.83189 8.7955C2.61126 9.00647 2.31202 9.125 2 9.125Z",
    stroke: "#838FB4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 4.125C6.31202 4.125 6.61126 4.24353 6.83189 4.4545C7.05252 4.66548 7.17647 4.95163 7.17647 5.25C7.17647 4.95163 7.30042 4.66548 7.52105 4.4545C7.74168 4.24353 8.04092 4.125 8.35294 4.125C8.04092 4.125 7.74168 4.00647 7.52105 3.7955C7.30042 3.58452 7.17647 3.29837 7.17647 3C7.17647 3.29837 7.05252 3.58452 6.83189 3.7955C6.61126 4.00647 6.31202 4.125 6 4.125Z",
    stroke: "#838FB4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 2.125C11.312 2.125 11.6113 2.24353 11.8319 2.4545C12.0525 2.66548 12.1765 2.95163 12.1765 3.25C12.1765 2.95163 12.3004 2.66548 12.5211 2.4545C12.7417 2.24353 13.0409 2.125 13.3529 2.125C13.0409 2.125 12.7417 2.00647 12.5211 1.7955C12.3004 1.58452 12.1765 1.29837 12.1765 1C12.1765 1.29837 12.0525 1.58452 11.8319 1.7955C11.6113 2.00647 11.312 2.125 11 2.125Z",
    stroke: "#838FB4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 4.125C16.312 4.125 16.6113 4.24353 16.8319 4.4545C17.0525 4.66548 17.1765 4.95163 17.1765 5.25C17.1765 4.95163 17.3004 4.66548 17.5211 4.4545C17.7417 4.24353 18.0409 4.125 18.3529 4.125C18.0409 4.125 17.7417 4.00647 17.5211 3.7955C17.3004 3.58452 17.1765 3.29837 17.1765 3C17.1765 3.29837 17.0525 3.58452 16.8319 3.7955C16.6113 4.00647 16.312 4.125 16 4.125Z",
    stroke: "#838FB4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.125C20.312 9.125 20.6113 9.24353 20.8319 9.4545C21.0525 9.66548 21.1765 9.95163 21.1765 10.25C21.1765 9.95163 21.3004 9.66548 21.5211 9.4545C21.7417 9.24353 22.0409 9.125 22.3529 9.125C22.0409 9.125 21.7417 9.00647 21.5211 8.7955C21.3004 8.58452 21.1765 8.29837 21.1765 8C21.1765 8.29837 21.0525 8.58452 20.8319 8.7955C20.6113 9.00647 20.312 9.125 20 9.125Z",
    stroke: "#838FB4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_31560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromptBuilder);
export default __webpack_public_path__ + "static/media/prompt_builder.210840c536fbdf1666166834cc6a0bf5.svg";
export { ForwardRef as ReactComponent };